export default __webpack_public_path__ + "static/continuous-integration-2-ff0587cca0e438eabc2db67a892f984b.png";